import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SubscriptionService } from '../services/subscription.service';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionGuard implements CanActivate {

  constructor(
    private subscriptionService: SubscriptionService,
     private router: Router
    ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return true;
    // // Check if the user has a valid subscription
    // if (this.subscriptionService.hasValidSubscription()) {
    //   return true; 
    // } else {
    //   // Redirect to a specific route (e.g., subscription page)
    //   this.router.navigate(['/subscription']); 
    //   return false;
    // }
  }
}